





















import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';

// directly exposed from vuetify/types no intention to change
import { InputValidationRules } from 'vuetify/types';
import {
  IEmployeeFormSubmissionChecklist,
  IUser,
  IUserData,
  User
} from '@/models';

export type EmployeeUserPickerType = (number | IUser)[] | number | IUser;

export default Vue.extend({
  name: 'EmployeeFormAssigneePicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Array, Number, Object] as PropType<IUser>,

    checklist: Object as PropType<IEmployeeFormSubmissionChecklist>,

    externalErrorMessage: {
      type: [String, Array] as PropType<string | string[]>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: {} as IUser,
      checklistAssigneeOptions: null as null | IUser[],
      search: '',
      errorMessage: '',
      loading: false
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true,
      deep: true
    },

    checklist: {
      handler(value) {
        this.loading = true;
        this.fetchChecklistAssigneeOptions(value)
          .then((data: IUserData[]) => {
            //assign value locally instead of in state
            this.checklistAssigneeOptions = data.map(
              assignee => new User(assignee)
            );
          })
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      immediate: true
    }
  },

  computed: {
    internalValue: {
      get(): IUser {
        return this.lazyValue;
      },
      set(val: IUser) {
        this.lazyValue = val;
        this.$emit('input', val);
        this.$emit('change', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    internalMessages(): InputValidationRules {
      if (!this.externalErrorMessage) {
        return [];
      } else if (Array.isArray(this.externalErrorMessage)) {
        return this.externalErrorMessage;
      } else {
        return [this.externalErrorMessage];
      }
    },

    errorMessageList(): InputValidationRules {
      const errorList = this.internalMessages;
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  methods: {
    ...mapActions({
      fetchChecklistAssigneeOptions:
        'employeeForm/fetchChecklistAssigneeOptions'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
    }
  }
});
